import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText } from '@mui/material';

const Privacy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography variant="h1" gutterBottom>
        Privacyverklaring
      </Typography>
      
      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Inleiding
        </Typography>
        <Typography variant="body1" paragraph>
          Bij Sterk aan het Werk hecht ik veel waarde aan de bescherming van jouw persoonsgegevens. In dit privacybeleid leg ik uit welke gegevens ik verzamel, waarom ik deze verzamel en hoe ik deze bescherm.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Welke gegevens verzamel ik?
        </Typography>
        <Typography variant="body1" paragraph>
          Ik verzamel alleen de gegevens die nodig zijn voor het leveren van mijn diensten:
        </Typography>
        <ul>
          <li>Naam en contactgegevens</li>
          <li>E-mailadres</li>
          <li>Telefoonnummer</li>
          <li>Informatie over uw loopbaan en professionele doelen</li>
        </ul>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Hoe gebruik ik jouw gegevens?
        </Typography>
        <Typography variant="body1" paragraph>
          Jouw gegevens worden gebruikt voor:
        </Typography>
        <List>
          <ListItem>
            <ListItemText primary="Het leveren van mijn coaching- en trainingsdiensten" />
          </ListItem>
          <ListItem>
            <ListItemText primary="Het verbeteren van mijn diensten" />
          </ListItem>
        </List>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Beveiliging
        </Typography>
        <Typography variant="body1" paragraph>
          Ik neem passende technische en organisatorische maatregelen om jouw persoonsgegevens te beschermen tegen verlies of onrechtmatige verwerking.
        </Typography>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Uw rechten
        </Typography>
        <Typography paragraph>
          U heeft het recht om:
        </Typography>
        <ul>
          <li>Uw gegevens in te zien</li>
          <li>Uw gegevens te corrigeren</li>
          <li>Uw gegevens te laten verwijderen</li>
          <li>Bezwaar te maken tegen de verwerking van uw gegevens</li>
        </ul>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h2" gutterBottom>
          Contact
        </Typography>
        <Typography paragraph>
          Voor vragen over dit privacybeleid kunt u contact opnemen via:
        </Typography>
        <Typography>
          Email: info@sterkaaninhetwerk.nl<br />
          Telefoon: 06-12345678
        </Typography>
      </Box>
    </Container>
  );
};

export default Privacy; 
